import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "@/models";
import { isFiatMarketCode } from "@/utils/fiatMarket";
import icon404 from "assets/images/common/icon404.png";
import { getFiatCurrencyIconSvg, getFiatCurrencyLetter } from "./fiatCurrencyIcons";
import styles from "./FiatCurrencyIcon.module.scss";

/** 与 web-index 资产概览/法币充值页一致：这些法币使用内联 SVG */
const FIAT_SVG_CODES = new Set(["AED", "SAR", "BRL", "VND"]);

function mergeClassName(className) {
  return className ? `${styles.icon} ${className}` : styles.icon;
}

/**
 * 币种图标（与 web-index /wallet/account/overview 资产列表一致）
 * - 法币 AED/SAR/BRL/VND：内联 SVG
 * - 其它法币：首字母
 * - 加密货币：fund.currencyMap / currencyList 的 logo（同 SpotAcc.icon）
 * @param {string} code - 币种代码
 * @param {string} className - 样式类名，如 styles["convert-buy__currency-icon"]
 * @param {object} style - 可选，用于首字符时的背景色等
 */
function FiatCurrencyIcon({ code, className, style = {} }) {
  const { fund } = useStore();
  const upper = String(code || "").toUpperCase();
  const lower = upper.toLowerCase();
  const rootClass = mergeClassName(className);

  const svg = getFiatCurrencyIconSvg(code);
  if (svg && FIAT_SVG_CODES.has(upper)) {
    return (
      <span
        className={rootClass}
        style={{ ...style, background: "transparent" }}
        dangerouslySetInnerHTML={{ __html: svg }}
      />
    );
  }

  if (isFiatMarketCode(upper)) {
    return (
      <span className={rootClass} style={style}>
        {getFiatCurrencyLetter(code)}
      </span>
    );
  }

  const logo = fund.getCurrencyIcon(lower);
  if (logo && logo !== icon404) {
    return <img src={logo} alt="" className={rootClass} style={style} />;
  }

  return (
    <span className={rootClass} style={style}>
      {getFiatCurrencyLetter(code)}
    </span>
  );
}

export default observer(FiatCurrencyIcon);
